<script setup lang="ts">
import {withDefaults, defineProps} from 'vue';
import HeaderGnb from '~/components/layout/gnb.vue';
import SubBreadCrumb from '~/components/ui/breadcrumb/breadcrumb.vue';
import MobileMenu from '~/components/layout/mobilemenu.vue';


// breadcrumb 기본은 false로 메인페이지에서는 안보이지만 서브페이지에서는 보이도록 함
const props = withDefaults(
  defineProps<{
    showBreadCrumb? : boolean;
  }>(),
    {
      showBreadCrumb : false,
    }
);

/**
 * 즐겨찾기 버튼
 *
 * @params none
 * @return none
 * @author utis
 * @see    ~/composables/useBookmarkHint
 */
import { useBookmarkHint } from '~/composables/useBookmark'

const { showBookmarkHelp } = useBookmarkHint()

/**
 * 즐겨찾기 버튼 클릭 핸들러
 *
 * @params none
 * @return void
 * @author utis
 * @see    useBookmarkHint.showBookmarkHelp
 */
const onClickFavorite = (): void => {
  showBookmarkHelp()
}

/**
 * 사이트 퍼센트 컨트롤 (전역 스토어 연동)
 *
 * @params none
 * @return none  (increase/decrease 호출로 제어, label 표시)
 /** @author utis
 * @see    ~/composables/useViewportZoom
 */
import { useViewportZoom } from '~/composables/useZoom'
const { label, increase, decrease /*, reset*/ } = useViewportZoom()


</script>

<template>
  <header>
      <div class="header-pc-box">
        <div class="header-top">
          <div class="top-wrap">
            <div class="favorite">
              <a-button class="common-button favorite-btn" type="text" @click="onClickFavorite">
                <span class="icon-span">
                  <img src="~/assets/img/pc/main/star.svg" alt="favorite" />
                </span>
                <span class="text-span">
                    즐겨찾기
                </span>
              </a-button>
            </div>
            <div class="line"></div>
            <div class="site-persent-box">
              <a-button class="common-button site-persent-btn" type="text" aria-label="축소" @click="decrease">
                <img src="~/assets/img/pc/main/minus-button.svg" alt="minus" />
              </a-button>

              <span class="persent-text">{{ label }}</span>

              <a-button class="common-button site-persent-btn" type="text" aria-label="확대" @click="increase">
                <img src="~/assets/img/pc/main/plus-button.svg" alt="plus" />
              </a-button>
            </div>
          </div>
        </div>
          <div class="header-container">
              <div class="header-inner">
                <div class="logo">
                  <NuxtLink to="/">
                    <img src="~/assets/img/pc/main/logo.svg" alt="logo" />
                  </NuxtLink>
                </div>
                <div class="gnb-box">
                  <HeaderGnb />
                </div>
                <div class="sitemap-box">
                  <NuxtLink class="sitemap-btn" :to="'/etc/sitemap'">
                    <img src="~/assets/img/pc/main/sitemap.svg" alt="sitemap" />
                  </NuxtLink>
                </div>
              </div>
          </div>
          <SubBreadCrumb v-if="props.showBreadCrumb" />
      </div>
    <div class="header-mobile-box">
        <div class="header-top">
          <div class="logo-box">
            <NuxtLink to="/">
              <img src="~/assets/img/pc/main/logo.svg" alt="logo" />
            </NuxtLink>
          </div>
          <div class="mobile-menu-box">
            <NuxtLink  to="http://newrnd.utp.or.kr/RSS/smart/Search.jsp" target="_blank" rel="noopener noreferrer">
              <img src="~/assets/img/mobile/mind-map.svg" alt="지식맵" />
            </NuxtLink>
            <MobileMenu />
          </div>
        </div>
      <SubBreadCrumb v-if="props.showBreadCrumb" />
    </div>
  </header>
</template>

<style scoped>

</style>